import { Link, useNavigate, useLocation } from "react-router-dom";

function Sidebar({ onLinkClick }) {  // Change prop name to be more generic
  const location = useLocation();

  const links = [
    { path: "/dashboard", label: "🏠 Dashboard" },
    { path: "/customers", label: "👥 Customers" },
    { path: "/employees", label: "🧑‍💼 Employees" },
    { path: "/projects", label: "📁 Projects" },
    { path: "/payments", label: "💰 Payments" },
    { path: "/incomes", label: "📈 Income" },
    { path: "/expense-categories", label: "🏷️ Expenses Categories" },
    { path: "/expenses", label: "💸 Expenses" },
    { path: "/withdrawals", label: "🏦 Withdrawals" },
    { path: "/report", label: "📊 Reports" },
    { path: "/users", label: "👥 Users" },
  ];

  // Function to handle link click
  const handleLinkClick = () => {
    // Call the parent function to close sidebar
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <div className="w-full h-full bg-gradient-to-b from-gray-900 to-gray-800 text-white p-6 overflow-hidden">
      <div className="h-full overflow-auto hide-scrollbar">
        {/* Header */}
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Admin Panel
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto mt-2 rounded-full"></div>
        </div>

        {/* Navigation */}
        <nav className="space-y-1">
          {links.map((link) => {
            const isActive = location.pathname.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                onClick={handleLinkClick} // Add click handler
                className={`flex items-center p-3 rounded-xl transition-all duration-300 group
                  ${isActive 
                    ? "bg-gradient-to-r from-blue-600 to-purple-600 shadow-lg shadow-blue-500/25 font-semibold transform scale-[1.02]" 
                    : "hover:bg-gray-750 hover:translate-x-1 hover:shadow-md"
                  }`}
              >
                <span className={`text-lg mr-3 transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`}>
                  {link.label.split(' ')[0]}
                </span>
                <span className="font-medium">
                  {link.label.split(' ').slice(1).join(' ')}
                </span>
                {isActive && (
                  <div className="ml-auto w-2 h-2 bg-white rounded-full animate-pulse"></div>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-700">
          <p className="text-xs text-gray-400 text-center">
            Secure Admin Portal
          </p>
        </div>
      </div>

      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .bg-gray-750 {
          background-color: #374151;
        }
      `}</style>
    </div>
  );
}

export default Sidebar;